
























import { Vue, Component, Prop } from 'vue-property-decorator';
import './tabs-nav.scss';
import UserModule from '@/store/user';

@Component
export default class TabsNavIcons extends Vue {
    @Prop({ 
        default: () => (
            {
                1: {
                    id: '1',
                    name: 'One',
                },
                2: {
                    id: '2',
                    name: 'Two',
                },
                3: {
                    id: '3',
                    name: 'Three',
                },
            }
        )
    }) items!: Record<string, unknown>;
    @Prop() actionHandler!: string;
    @Prop({ default: () => ({}) }) params!: Record<string, unknown>;
    @Prop({ default: '1' }) activeId!: string;
    @Prop({ default: '1' }) instanceId!: string;
    @Prop({ default: '1' }) parentLvl!: string;

    translatePos = 0;
    touchPos = 0;
    overflowRatio = 10;
    toRight = 'to-right';
    toLeft = 'to-left';
    screenWidth = 0;
    offsetWidth = 0;
    currentId: string | null = null;
    posBeforeScroll = 0;
    isiOs = false;

    get userRole() {
        return UserModule.role;
    }

    isUserAllowed(routeName: string) {
        const route = this.$router.getRoutes().find(route => route.name === routeName);
        return route?.meta.roles?.includes(UserModule.role);
    }

    beforeMount() {
        this.currentId = this.activeId;
    }
    updated() {
        this.currentId = this.activeId;
    }
}
